import { Spin } from 'antd';
import { useAppSelector } from 'app/store';
import { viewerModel } from 'entities/viewer';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { SortCondition } from 'shared/enums';
import { dataForPollsInfoTable, sortingDate } from 'shared/helpers/utils';
import { usePullSort } from 'shared/hooks';
import { PollTabs, SearchKeysPoll } from 'shared/enums/poll';
import { TPollSearchType, TPollsColumns } from 'shared/types/poll.types';
import PollTable from 'features/tables/pollsTable';
import { useLazyGetPollQuery } from 'app/services/edpApiV1/poll';

const PollUnpublicated = () => {
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [currentSize, setCurrentSize] = useState<number>(10);
  const [searchObject, setSearchObject] = useState<TPollSearchType>({
    data: undefined,
    key: SearchKeysPoll.SEARCH_NAME,
  });
  const [sortInfo, trigger] = usePullSort();

  const { role } = useAppSelector(viewerModel.me.selectors.selectViewerProfile);
  const { search } = useAppSelector(state => state.entities.search);
  const [getPollLazy, result] = useLazyGetPollQuery();

  const onSearch = (data: string, key: SearchKeysPoll) => {
    setSearchObject({ data: data ? data : undefined, key });
  };

  useEffect(() => {
    getPollLazy({
      size: currentSize,
      page: currentPage,
      type: PollTabs.UNPUBLICATED,
      orderDate: sortInfo.value ? sortInfo.value : undefined,
      [searchObject.key]: searchObject.data,
    });
  }, [currentPage, currentSize, getPollLazy, search, sortInfo.value, searchObject]);

  const columns: TPollsColumns = [
    {
      title: '№',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: 'Дата',
      dataIndex: 'created',
      key: 'created',
      sortDirections: [SortCondition.ASCEND, SortCondition.DESCEND],
      sorter: true,
      onHeaderCell: _ => ({
        onClick: () => trigger(),
      }),
    },
    {
      title: 'Заголовок',
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: 'Действие',
      key: 'action',
      render: (text, record) => {
        return <Link to={`/polls/update/${record.id}`}>Редактировать</Link>;
      },
    },
    {
      title: 'Автор',
      dataIndex: 'fio',
      key: 'fio',
    },
  ];
  return (
    <Spin spinning={result.isLoading || result.isFetching}>
      {result.data?.data ? (
        <PollTable
          dataSource={dataForPollsInfoTable(result?.data?.data) || []}
          columns={columns}
          currentPage={currentPage}
          currentSize={currentSize}
          setCurrentPage={setCurrentPage}
          setCurrentSize={setCurrentSize}
          total={result.data?.pagination.total}
          onSearch={onSearch}
        />
      ) : null}
    </Spin>
  );
};

export default PollUnpublicated;
